import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';

const GET_BASE_CLASSROOM_QUERY = gql`
  query getBaseClassroom($id: Int!) {
    entity: classroom(where: { id: $id }) {
      ...BaseClassroom
    }
  }
  ${CLASSROOM_FRAGMENT}
`;

export default GET_BASE_CLASSROOM_QUERY;
